import api from '../_api';

const actions = {
    orderRequest: ({commit, dispatch}, payload) => {

        return new Promise((resolve, reject) => {
            commit('ORDER_LOADING');

            let payload_orig = '';

            if(payload){
                payload_orig = payload.orig;
            }

            api.orders(payload_orig)
                .then((resp) => {
                    commit('ORDER_SUCCESS', resp.data.data);
                    resolve(resp.data);
                })
                .catch((err) => {
                    let errors = err.response.data.errors ? err.response.data.errors.error : err.response.data.error;

                    commit('ORDER_ERROR', errors);
                    reject(err.response);
                });
        })
    },
    orderDetailRequest: ({commit, dispatch}, payload) => {

        return new Promise((resolve, reject) => {
            commit('ORDER_LOADING');

            api.ordersdetail(payload.orderId)
                .then((resp) => {
                    commit('ORDER_SUCCESS', resp.data.data);
                    resolve(resp.data);
                })
                .catch((err) => {
                    let errors = err.response.data.errors ? err.response.data.errors.error : err.response.data.error;

                    commit('ORDER_ERROR', errors);
                    reject(err.response.data.error[0]);
                });
        })
    },
    paymentRequest: ({commit, dispatch}, payload) => {

        return new Promise((resolve, reject) => {
            commit('ORDER_LOADING');

            let payload_orig = '';

            if(payload){
                payload_orig = payload.orig;
            }

            api.payments(payload_orig)
                .then((resp) => {
                    commit('PAYMENT_SUCCESS', resp.data.data);
                    resolve(resp.data);
                })
                .catch((err) => {
                    let errors = err.response.data.errors ? err.response.data.errors.error : err.response.data.error;

                    commit('ORDER_ERROR', errors);
                    reject(err.response);
                });
        })
    },
    orderReceipt: ({commit, dispatch}, payload) => {
        return new Promise((resolve, reject) => {

            commit('ORDER_LOADING');
            api.sendReceipt(payload.orderId)
                .then((resp) => {
                    // console.log(resp)
                    commit('ORDER_SENT_SUCCESS');
                    resolve('Receipt sent successfully');
                })
                .catch((err) => {
                    // console.log(err)
                    commit('ORDER_SENT_ERROR');
                    reject(err.response.data.error[0]);
                });
        })
    },
    clearOrderErrors:({commit}) => {
        commit('CLEAR_ORDER_ERRORS');
    },
}

export default actions
